<template>
  <b-card>
    <b-card-header>
      <b-card-title>آپلود فایل</b-card-title>
    </b-card-header>
    <b-card-body>
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="`attachment">
                <feather-icon
                    icon="PaperclipIcon"
                />
                فایل
              </label>
              <b-form-file
                  v-model="file"
                  placeholder="فایل را انتخاب کنید یا به اینجا بکشید"
                  drop-placeholder="عکس را به اینحا بکشید"
                  no-drop
                  accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              />
              <a class="d-inline-block mt-2" href="/مانده%20مرخصی.xlsx">
                <span>برای دریافت نمونه فایل آپلودی اینجا کلیک کنید</span>
              </a>
            </b-form-group>
          </b-col>
          <b-col md="6" class="mt-2">
            <b-button
                variant="success"
                :disabled="onProgress"
                @click="createRequest"
            >
              <b-spinner
                  v-if="onProgress"
                  small
              />
              {{ onProgress ? 'درحال پردازش درخواست...' : 'آپلود فایل ' }}
            </b-button>
          </b-col>
        </b-row>


      </b-form>
    </b-card-body>
  </b-card>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BCardTitle,
  BSpinner,
  BButton,
  BFormFile,
  BFormTextarea,
  BCardText,
} from 'bootstrap-vue'
import VSelect from 'vue-select'
import { quillEditor } from 'vue-quill-editor'
import { doubleRaf } from '@/libs/utils'

export default {
  name: 'RequestsCreate',
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    VSelect,
    BCardTitle,
    BSpinner,
    BButton,
    BFormFile,
    quillEditor,
    BFormTextarea,
    BCardText,

  },
  data() {
    return {
      getFieldProgress: false,
      onProgress: false,
      file:null,
      maxChar: 140,
    }
  },

  methods: {

    async createRequest() {
      if (!this.file) {
        this.$bvToast.toast('فایل نمیتواند خالی باشد', {
          title: 'خطا',
          toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
          variant: 'danger',
        })
        return false
      }

      this.onProgress = true
      this.onSaving = true

      const requestFormData = new FormData()

      requestFormData.append('file', this.file)
      await this.$http.post('upload-file-vacations', requestFormData, {
        header: [
          'Content-Type:multipart/form-data',
        ],
      })
          .then(({ data }) => {
            if (data.status) {
              this.file = null

              this.$bvToast.toast('آپلود فایل با موفقیت ثبت شد', {
                title: 'انجام درخواست',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'success',
              })
            } else {
              this.$bvToast.toast(data.message ?? 'آپلود فایل انجام نشد', {
                title: 'حطا',
                toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
                variant: 'danger',
              })
            }
          })
          .catch(error => {
            this.$bvToast.toast(error.response.data.message ?? 'ارتباط با وبسرویس انجام نشد', {
              title: 'خطا در دریافت اطلاعات',
              toaster: `b-toaster-top-${this.$store.state.appConfig.isRTL ? 'right' : 'left'}`,
              variant: 'danger',
            })
          })
          .finally(() => {
            this.onProgress = false
          })
    },
  },
}
</script>
